var _loadTime = (new Date()).getTime().toString(), _i = 1;
export default function() {
	return _loadTime + (_i++);
}